module.exports = __webpack_public_path__ + "img/tree-2.b3602069.png";